// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hTJbI","colMin":"styles_colMin__2SPan"};